'use client'
import ImvGridView from "../components/ImvGridView"
import ImvSearch from "../components/Home/ImvSearch"
import FaiNavbar from "../components/Navbar"
import Footer from "../components/Footer"
import { HomeHeader } from "../components/Home/HomeHeader"
import { useState } from "react"

export default function HomePage() {
    const [isCardOpen, setIsCardOpen] = useState(false)
    const [isContactOpen, setIsContactOpen] = useState(false)

    return (
        <main className={isCardOpen && ('bg-[red]')}>
            <FaiNavbar />

            <section className="min-h-screen h-full">
                <ImvSearch isOpen={isCardOpen} />
                <section className="semi-main-section flex flex-col gap-20 shadow-[inset_0rem_0rem_4rem_#000]">
                    <HomeHeader />
                    <ImvGridView isOpen={isCardOpen} setOpen={setIsCardOpen} />
                </section>
            </section>
            
            <Footer />
        </main>
    )
}